import React, { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material/styles';

const Subtitle: ComponentType<HTMLAttributes<HTMLSpanElement>> = styled('p')({
  color: '#6B778C',
  textDecorationColor: '#6B778C',
  fontWeight: 400,
  fontSize: '13px',
  margin: 0,
  padding: 0,
  textOverflow: 'ellipsis',
  overflowX: 'clip',
});

export default Subtitle;